/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type BudgetBatchItemErrorCode = (typeof BudgetBatchItemErrorCode)[keyof typeof BudgetBatchItemErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BudgetBatchItemErrorCode = {
  client_not_belong_to_analysis: "client_not_belong_to_analysis",
  invalid_income_amount_type: "invalid_income_amount_type",
  income_not_found: "income_not_found",
  complex_expense_item_not_found: "complex_expense_item_not_found",
  related_asset_item_not_found: "related_asset_item_not_found",
  amount_mismatch: "amount_mismatch",
  duplicate_guid: "duplicate_guid",
} as const;
